import React from 'react';
import { MetricCard } from './MetricCard';
import type { TrafficSummary } from '../../utils/traffic';
interface EngagementMetricsProps {
  summary: TrafficSummary;
}
function formatSeconds(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const rest = Math.round(seconds % 60);
  return `${minutes}:${String(rest).padStart(2, '0')}`;
}
export function EngagementMetrics({
  summary
}: EngagementMetricsProps) {
  return <section aria-label="Engagement metrics" className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-id="element-37" data-mp="jq9gzzw94ris">
      <MetricCard label="On page now" value={summary.liveNow.toLocaleString()} hint="Visitors active in the last 5 minutes" data-id="element-38" data-mp="et9c3sb51ut9" />
      <MetricCard label="Avg. dwell" value={formatSeconds(summary.avgSecondsOnPage)} hint="Mean time spent on the maintenance page" data-id="element-39" data-mp="ooaywhhxykso" />
      <MetricCard label="Returning" value={`${Math.round(summary.returningShare * 100)}%`} hint={`Visitors who loaded the page more than once · ${summary.viewsPerVisitor} loads each`} data-id="element-40" data-mp="204j3eogxo66z" />
      <MetricCard label="Support reach-out" value={`${Math.round(summary.supportClickRate * 100)}%`} hint={`${summary.supportEmailClicks.toLocaleString()} clicks on the support email`} data-id="element-41" data-mp="1wa267wcg75el" />
    </section>;
}